module.exports = __webpack_public_path__ + "media/Video 103.5ce93fcf.mp4";